import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
import { IconCloseCircle } from '../../../icons/svg/index';
import { withPixelLineHeight } from '../../../styles/functions.web';
const useStyles = makeStyles((theme) => {
    return {
        inputContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        label: Object.assign(Object.assign({ color: theme.palette.text01 }, withPixelLineHeight(theme.typography.bodyShortRegular)), { marginBottom: `${theme.spacing(2)}px`, '&.is-mobile': Object.assign({}, withPixelLineHeight(theme.typography.bodyShortRegularLarge)) }),
        fieldContainer: {
            position: 'relative',
            display: 'flex'
        },
        input: Object.assign(Object.assign({ backgroundColor: theme.palette.ui03, color: theme.palette.text01 }, withPixelLineHeight(theme.typography.bodyShortRegular)), { padding: '10px 16px', borderRadius: theme.shape.borderRadius, border: 0, height: '40px', boxSizing: 'border-box', width: '100%', '&::placeholder': {
                color: theme.palette.text02
            }, '&:focus': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.focus01}`
            }, '&:disabled': {
                color: theme.palette.text03
            }, '&.is-mobile': Object.assign({ height: '48px', padding: '13px 16px' }, withPixelLineHeight(theme.typography.bodyShortRegularLarge)), '&.error': {
                boxShadow: `0px 0px 0px 2px ${theme.palette.textError}`
            } }),
        icon: {
            position: 'absolute',
            top: '10px',
            left: '16px'
        },
        iconInput: {
            paddingLeft: '46px'
        },
        clearableInput: {
            paddingRight: '46px'
        },
        clearButton: {
            position: 'absolute',
            right: '16px',
            top: '10px',
            cursor: 'pointer',
            backgroundColor: theme.palette.action03,
            border: 0,
            padding: 0
        },
        bottomLabel: Object.assign(Object.assign({ marginTop: `${theme.spacing(2)}px` }, withPixelLineHeight(theme.typography.labelRegular)), { color: theme.palette.text02, '&.is-mobile': Object.assign({}, withPixelLineHeight(theme.typography.bodyShortRegular)), '&.error': {
                color: theme.palette.textError
            } })
    };
});
const Input = ({ accessibilityLabel, autoFocus, bottomLabel, className, clearable = false, disabled, error, icon, id, label, maxLength, name, onChange, onKeyPress, placeholder, type = 'text', value }) => {
    const styles = useStyles();
    const isMobile = isMobileBrowser();
    const handleChange = useCallback((e) => onChange(e.target.value), []);
    const clearInput = useCallback(() => onChange(''), []);
    return (React.createElement("div", { className: clsx(styles.inputContainer, className) },
        label && React.createElement("span", { className: clsx(styles.label, isMobile && 'is-mobile') }, label),
        React.createElement("div", { className: styles.fieldContainer },
            icon && React.createElement(Icon, { className: styles.icon, size: 20, src: icon }),
            React.createElement("input", Object.assign({ "aria-label": accessibilityLabel, autoFocus: autoFocus, className: clsx(styles.input, isMobile && 'is-mobile', error && 'error', clearable && styles.clearableInput, icon && styles.iconInput), disabled: disabled }, (id ? { id } : {}), { maxLength: maxLength, name: name, onChange: handleChange, onKeyPress: onKeyPress, placeholder: placeholder, type: type, value: value })),
            clearable && !disabled && value !== '' && React.createElement("button", { className: styles.clearButton },
                React.createElement(Icon, { onClick: clearInput, size: 20, src: IconCloseCircle }))),
        bottomLabel && (React.createElement("span", { className: clsx(styles.bottomLabel, isMobile && 'is-mobile', error && 'error') }, bottomLabel))));
};
export default Input;
